import axios from '@/libs/axios'

export default {
  state: {
    all_timeslots: [],
    day_timeslots: [],
    workspace_id: '',
    countdown: '',
    // services_this_workspace: [],
  },
  getters: {
    getAllTimeslots(state) {
      return state.all_timeslots
    },
    getDayTimeslots(state) {
      return state.day_timeslots
    },
    getCountdown(state) {
      return state.countdown
    }
    // getServicesThisWorkspace(state) {
    //   return state.services_this_workspace
    // }
  },
  mutations: {
    UPDATE_ALL_TIMESLOTS(state, data) {
      state.all_timeslots = data
    },
    UPDATE_WORKSPACE_ID(state, id) {
      state.workspace_id = id
    },
    UPDATE_COUNTDOWN(state, data) {
      state.countdown = data
    },
    UPDATE_DAY_TIMESLOTS(state, data) {
      state.day_timeslots = data
    },
    REMOVE_TIME_FROM_ALL_TIMESLOTS(state, dateAndTime) {
      const targetIndex = state.all_timeslots.days.indexOf(dateAndTime.date);
      if (targetIndex !== -1) {
        const timeIndex = state.all_timeslots.timeslots[targetIndex].indexOf(dateAndTime.time)
        if (timeIndex !== -1) {
          state.all_timeslots.timeslots[targetIndex].splice(timeIndex, 1)
        }
      }
    },
    REMOVE_TIME_FROM_DAY_TIMESLOTS(state, time) {
      const timeIndex = state.day_timeslots.indexOf(time)
        if (timeIndex !== -1) {
          state.day_timeslots.splice(timeIndex, 1)
        }
    },
    // UPDATE_SERVICES_THIS_WORKSPACE(state, services) {
    //   state.services_this_workspace = services
    // }
  },
  actions: {
    fetchAllDaysTimeslots(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/storefront/timeslots/multiple-days/${data.workspace}`, {services: [data.service]})
          .then(response => {
            // console.log(response.data.services)
            // ctx.commit('UPDATE_SERVICES_THIS_WORKSPACE', response.data.services)
            ctx.commit('UPDATE_ALL_TIMESLOTS', response.data.records_by_workspace)
            if (ctx.rootState.error.error_timeslot_status){
              ctx.commit('UPDATE_ERROR_TIMESLOT_STATUS', false)
            }
            ctx.commit('UPDATE_WORKSPACE_ID', response.data.id)
            resolve(response.data.records_by_workspace)
          })
          .catch(error => {
            ctx.commit('UPDATE_ERROR_TIMESLOT_STATUS', true)
            reject(error)
          })
      })
    },
    fetchDayTimeslotsAndCountdown(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/storefront/timeslots/single-day/${data.workspace}`, data)
          .then(response => {
            context.commit('UPDATE_COUNTDOWN', response.data.countdown)
            context.commit('UPDATE_DAY_TIMESLOTS', response.data.timeslots)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    setRecordLikeGuest(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/storefront/records/create/${data.workspace}`, data)
          .then(response => {
            // ctx.dispatch('fetchAllDaysTimeslots',  {workspace: data.workspace, service: data.services})
            if (ctx.rootState.error.error_booking_status) {
              ctx.commit('UPDATE_ERROR_BOOKING_STATUS', false)
            }
            resolve(response)
          })
          .catch(error => {
            ctx.commit('UPDATE_ERROR_BOOKING_STATUS', true)
            reject(error)
          })
      })
    },
  },
}
